import React from 'react';
import { Svg, Path, Defs, ClipPath, G, Rect } from 'react-native-svg';

export const AngryFaceIcon = ({ color = '#333333', size = 28 }) => (
    <Svg
        width={size}
        height={size}
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <G clipPath="url(#angry-face-id)">
            <Path
                d="M12.1906 12.7416C11.8502 13.3549 11.1961 13.7699 10.445 13.7699C9.34321 13.7699 8.45002 12.8767 8.45002 11.7749C8.45002 11.0238 8.86508 10.3697 9.47834 10.0294L8.44942 9.00043L10.3303 7.11952L14.0921 10.8813L12.2112 12.7622L12.1906 12.7416Z"
                fill={color}
            />
            <Path
                d="M19.755 13.7699C20.8568 13.7699 21.75 12.8767 21.75 11.7749C21.75 11.1074 21.4222 10.5165 20.9188 10.1544L22.0727 9.00043L20.1918 7.11952L16.43 10.8813L17.823 12.2744C18.0448 13.1345 18.8257 13.7699 19.755 13.7699Z"
                fill={color}
            />
            <Path
                d="M20.0407 17.1796C21.055 18.2543 21.5521 19.4646 21.7103 20.0974L19.1297 20.7425C19.0663 20.4886 18.7654 19.7039 18.1061 19.0053C17.4826 18.3446 16.544 17.7599 15.1 17.7599C13.656 17.7599 12.7175 18.3446 12.0939 19.0053C11.4346 19.7039 11.1338 20.4886 11.0703 20.7425L8.48974 20.0974C8.64794 19.4646 9.14509 18.2543 10.1594 17.1796C11.2094 16.0669 12.82 15.0999 15.1 15.0999C17.38 15.0999 18.9906 16.0669 20.0407 17.1796Z"
                fill={color}
            />
            <Path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.80002 15.0999C1.80002 7.75454 7.75463 1.79993 15.1 1.79993C22.4454 1.79993 28.4 7.75454 28.4 15.0999C28.4 22.4453 22.4454 28.3999 15.1 28.3999C7.75463 28.3999 1.80002 22.4453 1.80002 15.0999ZM15.1 4.45993C9.22371 4.45993 4.46002 9.22362 4.46002 15.0999C4.46002 20.9762 9.22371 25.7399 15.1 25.7399C20.9763 25.7399 25.74 20.9762 25.74 15.0999C25.74 9.22362 20.9763 4.45993 15.1 4.45993Z"
                fill={color}
            />
        </G>
        <Defs>
            <ClipPath id="angry-face-id">
                <Rect
                    width="28.8"
                    height="28.8"
                    fill="white"
                    transform="translate(0.600021 0.599976)"
                />
            </ClipPath>
        </Defs>
    </Svg>
);
